// From the licence package itself, not a component package, so setting the key at boot does not
// load the data grid (NEXT.md A2).
import { LicenseInfo } from "@mui/x-license-pro";

// See https://mui.com/x/introduction/licensing/#license-key-installation
LicenseInfo.setLicenseKey(
  "6a4c53aa5c6a9329fd7c3222b33afac6Tz0xMjgwOTksRT0xODA3NDg3OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI="
);
